const helpPageCards = [
    {
        title: "Getting Started",
        desc: "Master the basics of our platform with step-by-step guides on creating job postings, managing candidates, and setting up your hiring workflow.",
        image: 'card1',
        path: "/employer/help/getting-started",
        category: "Basics"
    },
    {
        title: "Dashboard",
        desc: "Learn how to navigate and utilize your dashboard effectively to monitor key metrics, access important features, and stay updated on recruitment activities.",
        image: 'card2',
        path: "/employer/help/dashboard",
        category: "Basics"
    },
    {
        title: "Job Posting Management",
        desc: "Create, manage, and optimize your job postings to attract the best candidates. Learn how to write compelling job descriptions and maximize visibility.",
        image: 'card3',
        path: "/employer/help/job-posting",
        category: "Hiring"
    },
    {
        title: "Candidate Screening",
        desc: "Streamline your candidate screening process with automated tools and best practices. Learn how to efficiently evaluate candidates and identify the best matches.",
        image: 'card4',
        path: "/employer/help/candidate-screening",
        category: "Hiring"
    },
    {
        title: "Team Collaboration",
        desc: "Enhance your team's hiring process with collaborative tools and features. Learn how to work together effectively to find and hire the best candidates.",
        image: 'card5',
        path: "/employer/help/team-collaboration",
        category: "Team"
    },
    // {
    //     title: "Reference Checking",
    //     desc: "Streamline your reference checking process with automated tools and templates. Gather valuable insights about candidates from their previous employers.",
    //     image: 'card6',
    //     path: "/employer/help/reference-checking",
    //     category: "Hiring"
    // },
    // {
    //     title: "Offer Management",
    //     desc: "Streamline your offer creation and management process with automated tools and templates. Create professional offers and track responses.",
    //     image: 'card7',
    //     path: "/employer/help/offer-management",
    //     category: "Hiring"
    // },
    // {
    //     title: "Onboarding",
    //     desc: "Create a seamless onboarding experience for new hires with automated workflows, document collection, and task management.",
    //     image: 'card8',
    //     path: "/employer/help/onboarding",
    //     category: "Hiring"
    // },
    {
        title: "Compliance Management",
        desc: "Ensure your hiring process complies with relevant laws and regulations. Manage documentation, track requirements, and maintain audit trails.",
        image: 'card9',
        path: "/employer/help/compliance",
        category: "Settings"
    },
    // {
    //     title: "Integration Management",
    //     desc: "Connect your hiring platform with other tools and systems to streamline your workflow. Set up and manage integrations with HRIS and other applications.",
    //     image: 'card10',
    //     path: "/employer/help/integrations",
    //     category: "Settings"
    // },
    {
        title: "Calendar Management",
        desc: "Efficiently manage your interview schedule and hiring timeline with our integrated calendar system, including availability management and automated reminders.",
        image: 'card11',
        path: "/employer/help/calendar",
        category: "Hiring"
    },
    {
        title: "Analytics and Reporting",
        desc: "Gain valuable insights into your hiring process with comprehensive analytics, custom reports, and performance metrics to improve your recruitment strategy.",
        image: 'card12',
        path: "/employer/help/analytics",
        category: "Analytics"
    },
    {
        title: "Applicant Management",
        desc: "Streamline your applicant review and management process with comprehensive tools for tracking, evaluating, and communicating with candidates.",
        image: 'card1',
        path: "/employer/help/applicants",
        category: "Hiring"
    },
    {
        title: "Interview Management",
        desc: "Streamline your interview process with automated scheduling, feedback collection, and interview analytics for better decision-making.",
        image: 'card2',
        path: "/employer/help/interviews",
        category: "Hiring"
    },
    {
        title: "Account Settings",
        desc: "Customize your account settings to match your organization's needs, including company information, user management, and notification preferences.",
        image: 'card3',
        path: "/employer/help/account-settings",
        category: "Settings"
    },
    // {
    //     title: "Billing and Subscriptions",
    //     desc: "Manage your subscription plan, billing information, and payment history. Choose the plan that best fits your hiring needs and scale as needed.",
    //     image: 'card4',
    //     path: "/employer/help/billing",
    //     category: "Account"
    // },
    {
        title: "Career Pages",
        desc: "Create and customize your company's career page to showcase your organization, highlight company culture, and attract top talent.",
        image: 'card5',
        path: "/employer/help/career-pages",
        category: "Branding"
    },
    {
        title: "Email Templates",
        desc: "Create and manage professional email templates for various stages of your hiring process, maintaining consistent communication with candidates.",
        image: 'card6',
        path: "/employer/help/email-templates",
        category: "Automation"
    },
    {
        title: "Form Templates",
        desc: "Create and manage custom forms for your hiring process, including application forms, assessment questionnaires, and feedback forms.",
        image: 'card7',
        path: "/employer/help/form-templates",
        category: "Automation"
    },
    {
        title: "Auto-Reject Criteria",
        desc: "Set up automated screening criteria to efficiently filter out unqualified candidates and save time in the application review process.",
        image: 'card8',
        path: "/employer/help/auto-reject",
        category: "Automation"
    },
    {
        title: "Interview Reminders",
        desc: "Set up automated interview reminders to ensure smooth scheduling and attendance, keeping candidates and interviewers informed.",
        image: 'card9',
        path: "/employer/help/interview-reminders",
        category: "Automation"
    },
    {
        title: "Notifications",
        desc: "Configure and manage your notification preferences to stay informed about important updates in your hiring process.",
        image: 'card10',
        path: "/employer/help/notifications",
        category: "Automation"
    },
    {
        title: "Security Settings",
        desc: "Manage your account security settings to protect sensitive information and ensure secure access to your hiring platform.",
        image: 'card11',
        path: "/employer/help/security-settings",
        category: "Settings"
    },
    {
        title: "Access Levels",
        desc: "Manage user access levels and permissions to control what team members can do within the platform.",
        image: 'card12',
        path: "/employer/help/access-levels",
        category: "Settings"
    },
    {
        title: "Company Information",
        desc: "Manage your company's profile information that appears across the platform, including branding, description, and social media links.",
        image: 'card1',
        path: "/employer/help/company-information",
        category: "Settings"
    },
    {
        title: "Contact Support",
        desc: "Get personalized assistance from our support team through multiple channels, including live chat, email, and scheduled consultations.",
        image: 'card2',
        path: "/employer/help/contact-support",
        category: "Support"
    }
];

export default helpPageCards;
  